export const appRoutes = {
    main: {
        route: '/app',
        get: () => `/app`,
    },
    account: {
        main: {
            route: '/app/account',
            get: () => `/app/account`,
        },
        login: {
            route: '/app/account/login',
            get: (next) => (next ? `/app/account/login?next=${next}` : `/app/account/login`),
            getWithAppleIdToken: (id_token) => `/app/account/login?apple_id_token=${id_token}`,
        },
        loginWithAppleFormPost: {
            route: '/api/account/loginWithAppleFormPost',
            get: () => `/api/account/loginWithAppleFormPost`,
        },
        create: {
            route: '/app/account/create',
            get: (next) => (next ? `/app/account/create?next=${next}` : `/app/account/create`),
        },
        forgotPassword: {
            route: '/app/account/forgotPassword',
            get: () => `/app/account/forgotPassword`,
        },
        resetPassword: {
            route: '/app/account/resetPassword/:token',
            get: (token) => `/app/account/resetPassword/${token}`,
        },
    },
    persons: {
        person: {
            route: '/app/persons/:user_name',
            get: (user_name) => `/app/persons/${user_name}`,
        },
    },
    pair: {
        main: {
            route: '/app/pair',
            get: () => '/app/pair',
        },
    },
    voucher: {
        main: {
            route: '/app/voucher',
            get: (credits, next) => {
                if (credits && next) {
                    return `/app/voucher?credits=${credits}&next=${next}`;
                }
                if (credits) {
                    return `/app/voucher?credits=${credits}`;
                }
                if (next) {
                    return `/app/voucher?next=${next}`;
                }
                return `/app/voucher`;
            },
        },
    },
    confirmEmail: {
        main: {
            route: '/app/confirmEmail/:token',
            get: (token) => `/app/confirmEmail/${token}`,
        },
    },
    revertEmail: {
        main: {
            route: '/app/revertEmail/:token',
            get: (token) => `/app/revertEmail/${token}`,
        },
    },
    logout: {
        main: {
            route: '/app/logout',
            get: (next) => (next ? `/app/logout?next=${next}` : `/app/logout`),
        },
    },
    contact: {
        main: {
            route: '/app/contact',
            get: () => `/app/contact`,
        },
    },
    privacyPolicy: {
        main: {
            route: '/app/privacy-policy',
            get: () => `/app/privacy-policy`,
        },
    },
    termsOfService: {
        main: {
            route: '/app/terms-of-service',
            get: () => `/app/terms-of-service`,
        },
    },
    cookiePolicy: {
        main: {
            route: '/app/cookie-policy',
            get: () => `/app/cookie-policy`,
        },
    },
    disclaimer: {
        main: {
            route: '/app/disclaimer',
            get: () => `/app/disclaimer`,
        },
    },
    dsar: {
        main: {
            route: '/app/dsar',
            get: () => `/app/dsar`,
        },
    },
    status: {
        emailConfirmed: {
            main: {
                route: '/app/status/email-confirmed',
                get: () => `/app/status/email-confirmed`,
            },
        },
        emailReverted: {
            main: {
                route: '/app/status/email-reverted',
                get: () => `/app/status/email-reverted`,
            },
        },
        accountClosed: {
            main: {
                route: '/app/status/account-closed',
                get: () => `/app/status/account-closed`,
            },
        },
        forgotPasswordEmailSent: {
            main: {
                route: '/app/status/forgot-password-email-sent',
                get: () => `/app/status/forgot-password-email-sent`,
            },
        },
        passwordHasBeenReset: {
            main: {
                route: '/app/status/password-has-been-reset',
                get: () => `/app/status/password-has-been-reset`,
            },
        },
        paired: {
            main: {
                route: '/app/status/paired',
                get: () => `/app/status/paired`,
            },
        },
        voucherApplied: {
            main: {
                route: '/app/status/voucher-applied',
                get: () => `/app/status/voucher-applied`,
            },
        },
    },
};
//# sourceMappingURL=app.js.map